import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Content = styled(motion.div)`

`

export const Title = styled(motion.h3)`
    margin: 0 0 1rem 0;
`

export const Option = styled(motion.button)`
    cursor: pointer;
    color: white;
    width: 100%;
    background-color: var(--secondary-color);
    border-radius: 10px;
    padding: 1rem 2rem;
    font-size: 1rem;
    margin: .4rem 0;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Nota = styled(motion.p)`
    font-size: .7rem;
`
